// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.definition-shell {
  display: grid;
  gap: 1.5rem;
  padding: 0.5rem 0;
}
.definition-shell > .page-header {
  padding: 1.25rem 1.5rem;
  background: #f4f7fa;
  border: 1px solid #dce4eb;
  border-left: 4px solid #0073e6;
  border-radius: 6px;
}
.definition-shell > .page-header h1 {
  margin: 0 0 0.25rem;
  font-size: 1.6rem;
  font-weight: 700;
  color: #1a2a38;
}
.definition-shell > .page-header p {
  margin: 0;
  font-size: 0.9rem;
  color: #56636f;
}

form {
  display: grid;
  gap: 1.25rem;
}

.card {
  background: #fff;
  border: 1px solid #dce4eb;
  border-radius: 6px;
  padding: 1.25rem 1.5rem;
  display: grid;
  gap: 1rem;
}
.card h2 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a2a38;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.mode-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 0.75rem;
}

.mode-option {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border: 1px solid #dce4eb;
  border-radius: 6px;
  background: #fbfcfd;
  cursor: pointer;
}

.mode-option input {
  margin-top: 0.2rem;
  width: 0.85rem;
  height: 0.85rem;
  min-height: 0.85rem;
  padding: 0;
}

.mode-option-body {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.mode-option-body small {
  color: #677684;
}

.field {
  display: grid;
  gap: 0.4rem;
}
.field span {
  font-size: 0.85rem;
  font-weight: 600;
  color: #445260;
}
.field.grow {
  flex: 1 1 auto;
  min-width: 0;
}

.hint {
  font-size: 0.8rem;
  color: #677684;
  line-height: 1.4;
}

input,
textarea,
select {
  border: 1px solid #c7d2da;
  border-radius: 4px;
  min-height: 2.6rem;
  padding: 0.5rem 0.65rem;
  font-size: 0.92rem;
  line-height: 1.35;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.15s ease;
}
input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: #0073e6;
  box-shadow: 0 0 0 2px rgba(0, 115, 230, 0.15);
}
input.invalid,
textarea.invalid,
select.invalid {
  border-color: #d9363e;
}

.param-list {
  display: grid;
  gap: 0.75rem;
}

.table-definition {
  display: grid;
  gap: 1rem;
}

.spreadsheet-card {
  min-width: 0;
}

.spreadsheet-card .section-header {
  align-items: flex-start;
}

.spreadsheet-card .empty-hint {
  margin-top: 0.35rem;
}

.table-meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem 1rem;
}

.table-column-list {
  display: grid;
  gap: 0.75rem;
}

.table-column-row {
  border: 1px solid #e8edf2;
  border-radius: 4px;
  background: #fbfcfd;
  padding: 0.75rem 1rem;
  display: grid;
  gap: 0.65rem;
}

.table-column-main {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.table-formula {
  min-width: 0;
}

.param-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}
.param-row .remove-btn {
  margin-top: 1.45rem;
  flex-shrink: 0;
}

.output-param-row {
  background: #f9fbfd;
  border: 1px solid #e8edf2;
  border-radius: 4px;
  padding: 0.75rem 1rem;
}

.empty-hint {
  margin: 0;
  font-size: 0.88rem;
  color: #8a97a3;
  font-style: italic;
}

.error {
  font-size: 0.82rem;
  color: #d9363e;
  margin: 0;
}

em.required {
  color: #d9363e;
  font-style: normal;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease;
  text-decoration: none;
}
.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.btn.primary {
  background: #0073e6;
  color: #fff;
  border-color: #0073e6;
}
.btn.primary:hover:not(:disabled) {
  background: #005bbf;
  border-color: #005bbf;
}
.btn.secondary {
  background: #fff;
  color: #334d6e;
  border-color: #c7d2da;
}
.btn.secondary:hover:not(:disabled) {
  background: #f0f4f8;
}
.btn.danger {
  background: #fff;
  color: #d9363e;
  border-color: #d9363e;
}
.btn.danger:hover:not(:disabled) {
  background: #fdf0f0;
}
.btn.small {
  padding: 0.35rem 0.75rem;
  font-size: 0.85rem;
}

.form-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.form-actions > .error {
  flex: 1 1 100%;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/custom-test-definitions/test-definition.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,iBAAA;AACF;AACE;EACE,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,kBAAA;AACJ;AACI;EACE,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AACN;AAEI;EACE,SAAA;EACA,iBAAA;EACA,cAAA;AAAN;;AAKA;EACE,aAAA;EACA,YAAA;AAFF;;AAOA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AAJF;AAME;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AALF;;AAQA;EACE,aAAA;EACA,2DAAA;EACA,YAAA;AALF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AALF;;AAQA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAUA;EACE,aAAA;EACA,WAAA;AAPF;AASE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,YAAA;AARJ;;AAYA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AATF;;AAcA;;;EAGE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,mCAAA;AAXF;AAaE;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AATJ;AAYE;;;EACE,qBAAA;AARJ;;AAcA;EACE,aAAA;EACA,YAAA;AAXF;;AAcA;EACE,aAAA;EACA,SAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,uBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,aAAA;EACA,2DAAA;EACA,iBAAA;AAXF;;AAcA;EACE,aAAA;EACA,YAAA;AAXF;;AAcA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;AAXF;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;AAXF;AAaE;EACE,mBAAA;EACA,cAAA;AAXJ;;AAeA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AAZF;;AAeA;EACE,SAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAZF;;AAiBA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;AAdF;;AAiBA;EACE,cAAA;EACA,kBAAA;AAdF;;AAmBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,0DAAA;EACA,qBAAA;AAhBF;AAkBE;EACE,aAAA;EACA,mBAAA;AAhBJ;AAmBE;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAjBJ;AAmBI;EACE,mBAAA;EACA,qBAAA;AAjBN;AAqBE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAnBJ;AAqBI;EACE,mBAAA;AAnBN;AAuBE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AArBJ;AAuBI;EACE,mBAAA;AArBN;AAyBE;EACE,wBAAA;EACA,kBAAA;AAvBJ;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AA1BF;AA4BE;EACE,cAAA;EACA,iBAAA;AA1BJ","sourcesContent":[".definition-shell {\n  display: grid;\n  gap: 1.5rem;\n  padding: 0.5rem 0;\n\n  > .page-header {\n    padding: 1.25rem 1.5rem;\n    background: #f4f7fa;\n    border: 1px solid #dce4eb;\n    border-left: 4px solid #0073e6;\n    border-radius: 6px;\n\n    h1 {\n      margin: 0 0 0.25rem;\n      font-size: 1.6rem;\n      font-weight: 700;\n      color: #1a2a38;\n    }\n\n    p {\n      margin: 0;\n      font-size: 0.9rem;\n      color: #56636f;\n    }\n  }\n}\n\nform {\n  display: grid;\n  gap: 1.25rem;\n}\n\n// ── Card ─────────────────────────────────────────────────────────────────────\n\n.card {\n  background: #fff;\n  border: 1px solid #dce4eb;\n  border-radius: 6px;\n  padding: 1.25rem 1.5rem;\n  display: grid;\n  gap: 1rem;\n\n  h2 {\n    margin: 0;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #1a2a38;\n  }\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.mode-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 0.75rem;\n}\n\n.mode-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border: 1px solid #dce4eb;\n  border-radius: 6px;\n  background: #fbfcfd;\n  cursor: pointer;\n}\n\n.mode-option input {\n  margin-top: 0.2rem;\n  width: 0.85rem;\n  height: 0.85rem;\n  min-height: 0.85rem;\n  padding: 0;\n}\n\n.mode-option-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.mode-option-body small {\n  color: #677684;\n}\n\n// ── Field ─────────────────────────────────────────────────────────────────────\n\n.field {\n  display: grid;\n  gap: 0.4rem;\n\n  span {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: #445260;\n  }\n\n  &.grow {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n}\n\n.hint {\n  font-size: 0.8rem;\n  color: #677684;\n  line-height: 1.4;\n}\n\n// ── Inputs ────────────────────────────────────────────────────────────────────\n\ninput,\ntextarea,\nselect {\n  border: 1px solid #c7d2da;\n  border-radius: 4px;\n  min-height: 2.6rem;\n  padding: 0.5rem 0.65rem;\n  font-size: 0.92rem;\n  line-height: 1.35;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease;\n\n  &:focus {\n    outline: none;\n    border-color: #0073e6;\n    box-shadow: 0 0 0 2px rgba(0, 115, 230, 0.15);\n  }\n\n  &.invalid {\n    border-color: #d9363e;\n  }\n}\n\n// ── Param list ────────────────────────────────────────────────────────────────\n\n.param-list {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.table-definition {\n  display: grid;\n  gap: 1rem;\n}\n\n.spreadsheet-card {\n  min-width: 0;\n}\n\n.spreadsheet-card .section-header {\n  align-items: flex-start;\n}\n\n.spreadsheet-card .empty-hint {\n  margin-top: 0.35rem;\n}\n\n.table-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.75rem 1rem;\n}\n\n.table-column-list {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.table-column-row {\n  border: 1px solid #e8edf2;\n  border-radius: 4px;\n  background: #fbfcfd;\n  padding: 0.75rem 1rem;\n  display: grid;\n  gap: 0.65rem;\n}\n\n.table-column-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.table-formula {\n  min-width: 0;\n}\n\n.param-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n\n  .remove-btn {\n    margin-top: 1.45rem; // align with input\n    flex-shrink: 0;\n  }\n}\n\n.output-param-row {\n  background: #f9fbfd;\n  border: 1px solid #e8edf2;\n  border-radius: 4px;\n  padding: 0.75rem 1rem;\n}\n\n.empty-hint {\n  margin: 0;\n  font-size: 0.88rem;\n  color: #8a97a3;\n  font-style: italic;\n}\n\n// ── Validation ────────────────────────────────────────────────────────────────\n\n.error {\n  font-size: 0.82rem;\n  color: #d9363e;\n  margin: 0;\n}\n\nem.required {\n  color: #d9363e;\n  font-style: normal;\n}\n\n// ── Buttons ───────────────────────────────────────────────────────────────────\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  font-size: 0.92rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  text-decoration: none;\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n\n  &.primary {\n    background: #0073e6;\n    color: #fff;\n    border-color: #0073e6;\n\n    &:hover:not(:disabled) {\n      background: #005bbf;\n      border-color: #005bbf;\n    }\n  }\n\n  &.secondary {\n    background: #fff;\n    color: #334d6e;\n    border-color: #c7d2da;\n\n    &:hover:not(:disabled) {\n      background: #f0f4f8;\n    }\n  }\n\n  &.danger {\n    background: #fff;\n    color: #d9363e;\n    border-color: #d9363e;\n\n    &:hover:not(:disabled) {\n      background: #fdf0f0;\n    }\n  }\n\n  &.small {\n    padding: 0.35rem 0.75rem;\n    font-size: 0.85rem;\n  }\n}\n\n// ── Form actions ──────────────────────────────────────────────────────────────\n\n.form-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n\n  > .error {\n    flex: 1 1 100%;\n    text-align: right;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
